import Layout from '../views/layout/layout'

export  default {
    path: '/resources',
        name: 'resources',
    component: Layout,
    children: [
    {
        path: '/directory',
        name: 'catalogMgr',
        component:()=>import('../views/resources/catalog/index'),
        meta: {title: '目录管理',keepAlive:true}
    },
    {
        path: '/fileManager',
        name: 'fileManage',
        component:()=>import('../views/resources/fileManage/index'),
        meta: {title: '文件管理',keepAlive:true}
    },
    {
        path: '/videoManager',
        name: 'videoManager',
        component:()=>import('../views/resources/videoManage/index'),
        meta: {title: '视频管理',keepAlive:true}
    },
    {
        path: '/afterSales',
        name: 'afterSales',
        component:()=>import('../views/resources/afterSales/index'),
        meta: {title: '维修服务预约'}
    }
]
}